__webpack_require__.p = "{{ .Values.PodUi.resourceBasePath }}js/";